import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext } from 'react';
export var FeaturesContext = /*#__PURE__*/React.createContext({});
export var FeaturesProvider = function FeaturesProvider(_ref) {
  var _ref$dialogFeatures = _ref.dialogFeatures,
    dialogFeatures = _ref$dialogFeatures === void 0 ? {} : _ref$dialogFeatures,
    children = _ref.children;
  return (
    /*#__PURE__*/
    /**
     * Defaults and platfrom feature flag values can be overriden if explicit props are injected. This serves two purposes:
     *
     * 1. Storybook knobs can be provisioned for features that are powered by platfrom feature flags
     *
     * 2. Consumer products like Confluence, Jira can run statsig based experiments, where the Statsig evaluation happens in the product's code
     * but the effect happens inside the code shipped by search platform.
     */
    React.createElement(FeaturesContext.Provider, {
      value: _objectSpread({}, dialogFeatures)
    }, children)
  );
};
export var useFeaturesContext = function useFeaturesContext() {
  return useContext(FeaturesContext);
};